import React from 'react'
import { useModel } from 'umi'
import { message as $message, Button, Space } from 'antd'
import { breakPriceExportOrder, breakPriceExportGoods } from '@/services/breakPrice'
import { loadLink } from '@/utils/file'
import { progressPrompt } from '@/modules/globals/components/ProgressPrompt'
import { DOING, COMPLETE } from '@/modules/globals/constants/progress'
import { EXPORT_BREAK_ORDER, EXPORT_BREAK_GOODS } from '@/modules/globals/constants/messageCenter'
import { SuccessTitle, FailTitle } from '@/modules/globals/components/ProgressPreview'
import styles from './index.less'

// const ProcessModel = ({ visible, onCancel, title, content, taskId, onFinish }) => {
//     return (
//         <Modal
//             width={550}
//             visible={visible}
//             maskClosable={false}
//             destroyOnClose={true}
//             footer={null}
//             title={title}
//             onCancel={onCancel}>
//             <Upload.TaskProgress id={taskId} onFinish={onFinish} content={content} />
//         </Modal>
//     )
// }

// type: order goods
const ExportAction = ({ type }) => {
    const { query } = useModel('useBreakPriceDrawer')
    const title = type === 'goods' ? '导出破价商品' : '导出破价订单'
    // const onExportOk = taskId => {
    //     const handelFinish = ({ result }) => {
    //         if (result?.errorMsg) {
    //             $message.error(result.errorMsg)
    //             return
    //         }
    //         if (result?.ossUrl) {
    //             loadLink({
    //                 filePath: result.ossUrl
    //             })
    //         }
    //     }

    //     const content = () => <div>正在导出中</div>

    //     const processModel = createAPI(ProcessModel, {
    //         visible: true,
    //         title,
    //         content,
    //         taskId,
    //         onFinish: e => {
    //             handelFinish(e)
    //             processModel.destroy()
    //         }
    //     })
    // }

    const handleClick = () => {
        const api = type === 'goods' ? breakPriceExportGoods : breakPriceExportOrder
        const dataDayRangeMap = {
            1: 'TODAY',
            3: 'NEARLY_THREE_DAY',
            7: 'NEARLY_SEVEN_DAY',
            15: 'NEARLY_FIFTEEN_DAY',
            30: 'NEARLY_THIRTY_DAY'
        }
        api({
            channelCoId: query.co.key,
            dataDayRange: dataDayRangeMap[query.day]
        }).then(response => {
            const { success, message, data } = response ?? {}
            if (!success) {
                $message.error(message)
                return
            }
            // onExportOk(data.taskId)

            const completeContent = ({ dataSource }) => {
                const result = dataSource?.result || {}

                return (
                    <Space style={{ width: '100%', padding: '30px 0px' }} align="center" direction="vertical">
                        {result?.ossUrl ? (
                            <SuccessTitle title={`${title}成功`} />
                        ) : (
                            <FailTitle title="导出失败" text={result?.errorMsg} />
                        )}
                    </Space>
                )
            }

            const footerBtn = ({ onCancel, dataSource }) => {
                const result = dataSource?.result || {}

                const handleClick = () => {
                    loadLink({
                        filePath: result.ossUrl
                    })
                    onCancel && onCancel()
                }

                if (!result?.ossUrl) {
                    return null
                }

                return (
                    <Button type="primary" onClick={handleClick}>
                        下载表格
                    </Button>
                )
            }

            progressPrompt({
                taskId: data.taskId,
                messageType: type === 'goods' ? EXPORT_BREAK_GOODS : EXPORT_BREAK_ORDER,
                renderContentMap: {
                    [DOING]: {
                        title: `${title}中....`,
                        progressHeader: `正在${title}，请等待`
                    },
                    [COMPLETE]: {
                        title: `${title}完成`,
                        completeContent,
                        footerBtn
                    }
                }
            })
        })
    }

    return (
        <Button onClick={handleClick} className={styles.btn} type="primary">
            {title}
        </Button>
    )
}

export default ExportAction
